import {SpinnerDotted} from 'spinners-react'
// import ClipLoader from 'react-spinners/ClipLoader'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {styled, SpacialFn, VisualFn} from "@yosmanyga/web-style";
import {ProgressProps} from '@yosmanyga/primitive-ui-spec'

const Progress = ({
  width, color,
  className,
}: ProgressProps & UnnormalizedStyleProps) => {
  return <SpinnerDotted
    size={(width as number) || 10}
    color={color}
    className={className}
  />
}

// const Progress = ({
//     size, color,
//     align, margin, position, opacity,
//     ...props
// }) => {
//     return <ClipLoader
//         loading={true}
//         color={color}
//         size={size}
//         css={`
//             ${SpacialFn.compileAlign(align)}
//             ${SpacialFn.compileMargin(margin)}
//             ${SpacialFn.compilePosition(SpacialFn.normalizePosition(position))}
//
//             ${VisualFn.compileOpacity(opacity)}
//         `}
//         {...props} // className
//     />
// }

const StyledProgress = styled(Progress)`
  ${({align}) => SpacialFn.compileAlign(align)}
  ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
  ${({position}) => SpacialFn.compilePosition(SpacialFn.normalizePosition(position))}
  ${({opacity}) => VisualFn.compileOpacity(opacity)}
  ${({transform}) => VisualFn.compileTransform(transform)}
`

export default StyledProgress
